import type { OrderRaw } from "../components/order"

export const USER_QUERY_STORAGE_KEY              = "nfans.users.query"
export const USER_CLASSIFICATIONS_STORAGE_KEY    = "nfans.users.classifications"
export const USER_ROLES_STORAGE_KEY              = "nfans.users.roles"
export const USER_STATES_STORAGE_KEY             = "nfans.users.states"
export const USER_HAS_LINKED_AUTHOR_STORAGE_KEY  = "nfans.users.hasLinkedAuthor"
export const USER_ORDER_STORAGE_KEY              = "nfans.users.order"

export const USER_ORDER_PROPERTIES: Array<OrderRaw> = [
  { label: "Name",             properties: [{ property: "displayName",      defaultDirection: "asc"  }] },
  { label: "Login",            properties: [{ property: "loginName",        defaultDirection: "asc"  }] },
  { label: "E-Mail",           properties: [{ property: "email",            defaultDirection: "asc"  }] },
  { label: "Zuletzt geändert", properties: [{ property: "lastModifiedDate", defaultDirection: "desc" }] },
  { label: "Erstellt",         properties: [{ property: "createdDate",      defaultDirection: "desc" }] },
]

export const CLASSIFICATION_LABEL = {
  EDITOR:    "Redakteur",
  COMMUNITY: "Community-Member",
} as const

export const STATE_LABEL = {
  ACTIVE:   "Aktiv",
  DISABLED: "Deaktiviert",
  PENDING:  "Ausstehend",
} as const
